/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import axios, { AxiosResponse, InternalAxiosRequestConfig } from "axios";
import { IErrorModel } from "../../../../models";
import { authStorage, sessionManager } from "../../../../services";

export const HttpRequestFulfilledInterceptor = (
  config: InternalAxiosRequestConfig,
  country: string
): InternalAxiosRequestConfig => {
  const session = authStorage.getSessionBehavior();
  const loginRegex = /\/login/gi;

  if (!config.headers) {
    config.headers = new axios.AxiosHeaders();
  }

  if (
    session &&
    session.Token &&
    !config.headers.hasOwnProperty("Authorization") &&
    config?.url &&
    !loginRegex.test(config.url)
  ) {
    config.headers["Authorization"] = `Bearer ${session.Token}`;
  }

  if (!config.headers["X-NF-Content-Country"]) {
    config.headers["X-NF-Content-Country"] = country.toUpperCase();
  }

  if (!config.headers?.["Content-Type"]) {
    config.headers["Content-Type"] = "application/json; charset=UTF-8";
  }

  return config;
};

export const HttpRequestRejectedInterceptor = (error: IErrorModel): any => {
  return Promise.reject(error);
};

export const HttpResponseFulfilledInterceptor = (
  response: AxiosResponse
): AxiosResponse => response;

export const HttpResponseRejectedInterceptor = async (
  error: IErrorModel | any
): Promise<any> => {
  const { config, response } = error;
  const originalRequest = config;

  if (!originalRequest || originalRequest._retry) {
    return Promise.reject(error);
  }

  if (response?.config?.url === "/v1/login") {
    return Promise.reject(error);
  }

  if (response?.config?.url === "/v1/refresh-tokens") {
    return Promise.reject(error);
  }

  if (!response || response.status === 401) {
    originalRequest._retry = true;

    try {
      const session = await sessionManager.refresh();

      originalRequest.headers["Authorization"] = `Bearer ${session.Token}`;

      return axios(originalRequest);
    } catch (refreshError) {
      return Promise.reject(refreshError);
    }
  }

  return Promise.reject(error);
};
